if (!customElements.get('theme-localization')) {
  const COUNTRY_OPTIONS_SECTION_ID = 'localization-country-options';
  let countryOptionsRequest = null;

  const fetchCountryOptions = () => {
    countryOptionsRequest ??= fetch(`${window.Shopify?.routes?.root ?? '/'}?section_id=${COUNTRY_OPTIONS_SECTION_ID}`)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        const wrapper = theme.utils.domParser.parseFromString(html, 'text/html')
          .querySelector(`#shopify-section-${COUNTRY_OPTIONS_SECTION_ID}`);
        if (!wrapper?.innerHTML.trim()) throw new Error('empty');
        return wrapper.innerHTML;
      })
      .catch((error) => {
        countryOptionsRequest = null;
        throw error;
      });
    return countryOptionsRequest;
  };

  class ThemeLocalization extends HTMLElement {
    constructor() {
      super();
      this.handleOptionClick = this.handleOptionClick.bind(this);
      this.loadOptions = this.loadOptions.bind(this);
      this.handlePanelToggle = this.handlePanelToggle.bind(this);
    }

    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.addEventListener('click', this.handleOptionClick, { signal });

      this.lazyPanel = this.querySelector('[data-lazy-options]');
      if (!this.lazyPanel) return;

      this.addEventListener('pointerenter', this.loadOptions, { signal });
      this.addEventListener('focusin', this.loadOptions, { signal });
      this.addEventListener('touchstart', this.loadOptions, { signal, passive: true });
      this.lazyPanel.addEventListener('toggle', this.handlePanelToggle, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    async loadOptions() {
      const panel = this.lazyPanel;
      if (!panel?.hasAttribute('data-lazy-options')) return;

      try {
        const html = await fetchCountryOptions();
        if (!panel.hasAttribute('data-lazy-options')) return;
        panel.innerHTML = html;
        panel.removeAttribute('data-lazy-options');
      } catch {
        return;
      }

      if (!panel.matches(':popover-open')) return;
      panel.closest('theme-dropdown')?.requestReposition();
      this.focusActiveOption();
    }

    handlePanelToggle(event) {
      if (event.newState !== 'open') return;
      if (this.lazyPanel.hasAttribute('data-lazy-options')) {
        this.loadOptions();
      } else {
        this.focusActiveOption();
      }
    }

    focusActiveOption() {
      const trigger = this.lazyPanel.closest('theme-dropdown')?.trigger;
      if (!trigger?.matches(':focus-visible')) return;

      requestAnimationFrame(() => {
        const options = this.lazyPanel.querySelectorAll('[role="option"]');
        const target = this.lazyPanel.querySelector('[aria-selected="true"]') ?? options[0];
        target?.focus();
      });
    }

    handleOptionClick(event) {
      const option = event.target.closest('[role="option"]');
      if (!option) return;

      option.closest('form')?.submit();
    }
  }

  customElements.define('theme-localization', ThemeLocalization);
}
